import config, {onemapbase_url} from "../config";

const baseUrl = config.onemapbase_url + "agri_species_phenology/";

export default {
    list: {
        url: baseUrl + "list",
        type: "get",
        // 支持传入 speciesId 参数查询该物种下的物候期列表
    },
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
};


